var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TheoryExamForm',{attrs:{"loading":_vm.isLoading},on:{"on-submit":_vm.onSubmit,"on-close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }